export const AiIndicatorIcon = () => {
	return (
		<svg
			width="20"
			height="20"
			viewBox="0 0 20 20"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M8.58949 5.59326C8.387 5.046 7.61296 5.04601 7.41046 5.59326C6.63742 7.68235 6.25089 8.72692 5.48889 9.48898C4.72689 10.2509 3.68233 10.6374 1.5932 11.4106C1.04596 11.6131 1.04596 12.3871 1.5932 12.5895C3.68233 13.3627 4.72689 13.7492 5.48889 14.5111C6.25089 15.2732 6.63742 16.3178 7.41046 18.4068C7.61296 18.9541 8.387 18.9541 8.58949 18.4068C9.36263 16.3178 9.74914 15.2732 10.5111 14.5111C11.2731 13.7492 12.3177 13.3627 14.4067 12.5895C14.954 12.3871 14.954 11.6131 14.4067 11.4106C12.3177 10.6374 11.2731 10.2509 10.5111 9.48898C9.74914 8.72692 9.36263 7.68235 8.58949 5.59326Z"
				fill="url(#paint0_linear_ai_indicator)"
			/>
			<path
				d="M16.2948 0.796661C16.1935 0.523005 15.8065 0.523005 15.7052 0.796661C15.3187 1.84122 15.1255 2.36351 14.7444 2.7445C14.3635 3.1255 13.8412 3.31877 12.7967 3.70529C12.523 3.80654 12.523 4.19358 12.7967 4.29483C13.8412 4.68135 14.3635 4.87462 14.7444 5.25562C15.1255 5.63661 15.3187 6.1589 15.7052 7.20346C15.8065 7.47712 16.1935 7.47712 16.2948 7.20346C16.6813 6.1589 16.8745 5.63661 17.2556 5.25561C17.6365 4.87462 18.1588 4.68135 19.2033 4.29483C19.477 4.19358 19.477 3.80654 19.2033 3.70529C18.1588 3.31877 17.6365 3.1255 17.2556 2.7445C16.8745 2.36351 16.6813 1.84122 16.2948 0.796661Z"
				fill="url(#paint1_linear_ai_indicator)"
			/>
			<defs>
				<linearGradient
					id="paint0_linear_ai_indicator"
					x1="8"
					y1="4.00006"
					x2="8"
					y2="20.0001"
					gradientUnits="userSpaceOnUse"
				>
					<stop stopColor="#9299F7" />
					<stop offset="1" stopColor="#F3107E" />
				</linearGradient>
				<linearGradient
					id="paint1_linear_ai_indicator"
					x1="16"
					y1="6.10352e-05"
					x2="16"
					y2="8.00006"
					gradientUnits="userSpaceOnUse"
				>
					<stop stopColor="#9299F7" />
					<stop offset="1" stopColor="#F3107E" />
				</linearGradient>
			</defs>
		</svg>
	);
};
